// extracted by mini-css-extract-plugin
export default {"menu":"_967d460272518841bf8237ffdec4b0f6"};